export type CalendarSavedView = {
  id: string;
  name: string;
  searchQuery: string;
  statusFilter: string;
  cityFilter: string;
  dateFrom: string;
  dateTo: string;
};

const STORAGE_KEY = "zoniq.calendar.savedViews";

export function readCalendarSavedViews(): CalendarSavedView[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as CalendarSavedView[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function writeCalendarSavedViews(views: CalendarSavedView[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(views));
  } catch {
    /* ignore */
  }
}

export function createCalendarSavedView(
  name: string,
  filters: Omit<CalendarSavedView, "id" | "name">,
): CalendarSavedView {
  return {
    id: `view-${Date.now()}`,
    name: name.trim(),
    ...filters,
  };
}
